import { TextField, FormControl } from '@mui/material'
import PropTypes from 'prop-types'

const FormikControl = ({
  variableName,
  labelName,
  handleChange,
  formik,
  forceHelper,
  type = 'text',
  variant = 'outlined',
  forceError = false,
  disabled = false,
  ...rest
}) => {
  return (
    <FormControl fullWidth>
      <TextField
        error={
          (formik.touched[variableName] &&
            Boolean(formik.errors[variableName])) ||
          forceError
        }
        disabled={disabled}
        label={labelName}
        type={type}
        autoComplete="off"
        value={formik.values[variableName] || ''}
        onChange={handleChange}
        id={variableName}
        name={variableName}
        helperText={
          (formik.touched[variableName] && formik.errors[variableName]) ||
          (forceError && forceHelper)
        }
        variant={variant}
        {...rest}
      />
    </FormControl>
  )
}

FormikControl.propTypes = {
  formik: PropTypes.object,
  variableName: PropTypes.string,
  labelName: PropTypes.string,
  handleChange: PropTypes.func,
  type: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  forceError: PropTypes.bool,
  forceHelper: PropTypes.string,
}

export default FormikControl
